<div class="header">
  <div class="header-cont">
    <h2>{{ 'new_user.title' | translate }}</h2>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'new_user.sections.name' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-form-field class="section-input">
      <mat-label>{{ 'new_user.sections.name' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="user_current.name" required>
    </mat-form-field>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'new_user.sections.auth' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-form-field class="section-input">
      <mat-label>{{ 'new_user.sections.auth' | translate }}</mat-label>
      <mat-select [(value)]="user_current.auth_user" (selectionChange)="authSelectionFunction()">
        <mat-option *ngFor="let single_auth of auth" [value]="single_auth">
          {{single_auth | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'new_user.sections.pwd' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-form-field class="section-input">
      <mat-label>{{ 'new_user.sections.pwd' | translate }}</mat-label>
      <input matInput type="password" [(ngModel)]="user_current.password" required>
    </mat-form-field>
  </div>
</div>  

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.geopos' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-selection-list #geoposSelection (selectionChange)="geoposSelectionFunction()">
      <mat-list-option *ngFor="let geopos of geopos_list" color="primary" [selected]="checkGeopos(geopos)" [disabled]="user_current.geopos.length > 0" [value]="geopos">
        <mat-icon matListIcon>explore</mat-icon>
        {{geopos.name[current_lang]}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="page-footer">
  <div class="page-footer-btns">
    <button mat-raised-button class="save-icon-btn" (click)="saveUser()" [disabled]="saveButtonDisabled()">
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
